import React from 'react';
import editPenOutlineIcon from '../../../../../assets/img/button-icons/edit-pen-outline.svg';
import TrashIcon from '../../../../../assets/img/button-icons/trash-red.svg';
import EyeIcon from '../../../../../assets/img/eye.png';
import ConfirmationModal from '../../../Modal/ConfirmationModal/ConfirmationModal';
import { MedicationForm } from '../../../../pages/MedicationProfile/components/MedicationDetail/editMedication/EditMedicationForm';

const MedicationMedicine = ({
  medication,
  canEdit,
  canViewOnly,
  isDeleting,
  onRequestDelete,
  onCancelDelete,
  onConfirmDelete,
  medicationProfileForm,
  onEditMedicationToSection,
  currentSection,
  confirmDelete,
}) => {
  const [openAddMedication, setOpenAddMedication] = React.useState(false);
  return (
    <>
      <div className="medication-row">
        <div className="medication-row-info">
          <div className="medication-row-label">{medication.medName}</div>
          <div
            className="medication-row-sublabel"
            dangerouslySetInnerHTML={{
              __html: medication.subheading ?? '',
            }}
          ></div>
          <div className="medication-row-sublabel">{medication.method}</div>
        </div>
        {(canEdit || canViewOnly) && (
          <div>
            {canViewOnly && !canEdit ? (
              <button
                className="medication-button"
                onClick={() => setOpenAddMedication(true)}
              >
                <img src={EyeIcon} className="icon" alt="view icon" />
              </button>
            ) : null}
            {canEdit ? (
              <button
                className="medication-button"
                onClick={() => setOpenAddMedication(true)}
              >
                <img
                  src={editPenOutlineIcon}
                  className="icon"
                  alt="edit pen icon"
                />
              </button>
            ) : null}
            {canEdit ? (
              <button
                className="medication-button"
                onClick={() => {
                  if (confirmDelete) {
                    onRequestDelete();
                    return;
                  }
                  onConfirmDelete(medication?.medId, currentSection);
                }}
              >
                <img src={TrashIcon} alt="trash icon" />
              </button>
            ) : null}
          </div>
        )}
        <ConfirmationModal
          showModal={isDeleting}
          onConfirm={onConfirmDelete}
          onCancel={onCancelDelete}
          right={100}
        />
      </div>
      <MedicationForm
        currentSection={currentSection}
        open={openAddMedication}
        onClose={() => setOpenAddMedication(false)}
        medicationProfileForm={medicationProfileForm}
        onSave={onEditMedicationToSection}
        medication={medication}
        readOnly={Boolean(canViewOnly && !canEdit)}
      />
    </>
  );
};

export default MedicationMedicine;
